import styled from 'styled-components';
import { media } from '@bitcoin-portal/bitcoincom-pkg-theme';
import Section from '@bitcoin-portal/bitcoincom-pkg-components/dist/Section';

export const StyledSection = styled(Section)`
  background: #ffffff !important;
  padding: 60px 0px !important;
  margin: 0px !important;
  overflow: hidden !important;

  ${media.md`
    padding: 60px 0px !important;
  `}

  ${media.xl`
    padding: 80px 0px !important;
  `}
`;

export const StyledContentBlock = styled.div`
  max-width: 1440px;
  padding: 0px !important;
  margin: auto;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: calc(100% - 40px);
  padding: 0px 20px !important;
  gap: 24px;

  ${media.md`
    width: calc(100% - 120px);
    padding: 0px 60px !important;
  `}

  ${media.xl`
    flex-direction: row;
    width: calc(100% - 160px);
    padding: 0px 80px !important;
    gap: 100px;
  `}
`;

export const ErrorBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  width: 100%;
  gap: 20px;

  ${media.xl`
    width: calc(52% - 50px);
  `}
`;

export const AnimatedErrorBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: auto;
`;

export const AnimatedSVG = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;

  ${media.xl`
    width: 440px;
  `}

  ${media.xl`
    width: 100%;
  `}
`;

export const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ErrorDescription = styled.p`
  color: #1c1c1c;
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 123%;
  margin: 0px;

  ${media.md`
    font-size: 16px;
  `}

  ${media.xl`
    font-size: 22px;
  `}
`;

export const ErrorActions = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #1c1c1c;
  border-radius: 108.019px;
  padding: 14px 28px;
  width: 100%;
  height: 52px;
  color: #ffffff;
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 130%;
  text-align: center;
  cursor: pointer;
  border: none;
  gap: 8.369px;
  margin-top: 4px;

  position: relative;
  overflow: hidden;
  z-index: 1;
  transition: background 0.3s ease, color 0.3s ease;

  &:hover {
    background: #434248;
  }

  ${media.md`
    font-size: 18.598px;
  `}

  .ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: ripple-animation 1.5s ease-out;
    background-color: rgba(255, 255, 255, 0.4);
    pointer-events: none;
    z-index: 0;
  }

  @keyframes ripple-animation {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
`;

export const RightArrow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f7931a;
  width: 26px;
  height: 26px;
  border-radius: 20px;
`;

export const ScanBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #f0f0f5;
  width: calc(100% - 48px);
  padding: 32px 24px;
  border-radius: 12px;
  gap: 16px;

  ${media.xl`
    width: calc(48% - 114px);
    height: -webkit-fill-available;
    padding: 32px;
  `}
`;

export const ScanTitle = styled.h2`
  color: #1c1c1c;
  font-family: 'Elza Condensed', sans-serif;
  font-size: 34px;
  font-weight: 900;
  line-height: 89%;
  letter-spacing: -0.68px;
  text-align: center;
  text-transform: uppercase;
  margin: 0px;

  ${media.md`
    font-size: 44px;
    line-height: 85%;
    letter-spacing: -0.88px;
  `}

  ${media.xl`
    font-size: 56px;
    line-height: 90%;
    letter-spacing: -1.12px;
  `}
`;

export const ScanText = styled.p`
  color: #1c1c1c;
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 135%;
  text-align: center;
  margin: 0px;

  ${media.md`
    font-size: 18px;
    line-height: 150%;
  `}

  ${media.xl`
    font-size: 22px;
    line-height: 123%;
  `}
`;

export const ScanImage = styled.img`
  width: 240px;
  height: 240px;
  border-radius: 12px;
`;

export const ScanLink = styled.a`
  color: #466ddc;
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: normal;
  text-decoration: none;
  text-align: center;
  cursor: pointer;
  margin: 0px;

  ${media.md`
    font-size: 16px;
    line-height: 135%;
    letter-spacing: -0.32px;
  `}

  ${media.xl`
    font-size: 20px;
    line-height: 130%;
    letter-spacing: normal;
  `}
`;
